export const hy = {
  title: 'Ծառի ծածկոց',
  subtitle: '2000/2010, Hansen/UMD/Google/USGS/NASA',
  download_data: 'https://glad.umd.edu/dataset/global-2010-tree-cover-30-m',
  learn_more: 'http://science.sciencemag.org/content/342/6160/850',
  content: [
    {
      label: 'Գործառույթ',
      value: 'Բնութագրում է ծառերի ծածկոցի տարածքները',
    },
    {
      label: 'Բանաձեւ',
      value: '30 × 30 մետր',
    },
    {
      label: 'Աշխարհագրական ծածկույթ',
      value: 'Գլոբալ հողեր (բացառությամբ Անտարկտիդայի եւ Արկտիկայի կղզիների)',
    },
    {
      label: 'Աղբյուր',
      value:
        'Հանսենը, Մ. Գ., Պ. Վ. Պոտապով, Ռ. Մուր, Մ. Հանչեր, Ս. Ա. Տուրուբերանովա, Ա. Տյոկավինա, Դ. Թաուն, Ս. Վ. Շտեհման, Ս. Յ. Գյոց, Տ. Ռ. Լովելանդ, Ա. Կոմմարեդդին, Ա. Էգորով, Լ. Չինին, Չ. Օ. Արդարադատություն եւ Ջ. Ռ. Գ. Թաունշենդ։ 2013. «21-րդ դարի անտառային ծածկույթի փոփոխության բարձր լուծաչափ ունեցող գլոբալ քարտեզներ»: Գիտություն 342 (15 նոյեմբեր): 850-53. Տվյալները հասանելի են: https://glad.umd.edu/dataset/global-2010-tree-cover-30-m.',
    },
    {
      label: 'Հաճախականություն',
      value: '',
    },
    {
      label: 'Բովանդակության ամսաթիվը',
      value: '2000 & 2010',
    },
    {
      label: 'Զգուշացումներ',
      value:
        'Այս ուսումնասիրության նպատակով «ծառի ծածկը» սահմանվել է որպես 5 մետրից բարձր բոլոր բուսականությամբ: "Tree cover"-ը ծառերի կենսաֆիզիկական առկայությունն է եւ կարող է ընդունել բնական անտառների կամ պլանտացիաների տեսք, որոնք գոյություն ունեն կանեփի մի շարք խտությունների վրա։',
    },
    {
      label: 'Լիցենզիա',
      value: 'CC by 4.0',
    },
  ],
  overview: {
    label: 'Ընդհանուր ակնարկ',
    value:
      'Այս տվյալների հավաքածուն, մերիլենդի, Google-ի, USGS-ի եւ ՆԱՍԱ-ի համալսարանի GLAD (Global Land Analysis &Discovery) լաբորատորիայի համագործակցությունը, ցույց է տալիս ծառերի ծածկույթը ամբողջ համաշխարհային ցամաքի վրա (բացառությամբ Անտարկտիդայի եւ մի շարք Արկտիկական կղզիների) 2000 եւ 2010 թվականների ընթացքում 30 × 30 մետր բանաձեւով: «Տոկոսային ծառի ծածկոցը» սահմանվում է որպես հողի մակերեւույթի ծառերի կանեփի ծածկույթի խտություն եւ գունավոր կոդավորված է խտության փակագծով (տես լեգենդ):\n\nԱյս շերտի տվյալները ստացվել են Լանդսաթ 7 թեմատիկ քարտեզի (ETM+) սենսորից բազմաշերտ արբանյակային պատկերի միջոցով: Ավելի քան 600000 պատկերների հստակ մակերեսային դիտարկումները վերլուծվել են Google Earth Engine-ի միջոցով, որը ամպերի հարթակ է երկրի դիտարկման եւ տվյալների վերլուծության համար, որոշելու համար մեկ պիքսել ծառի ծածկոցը՝ օգտագործելով վերահսկվող ուսումնական ալգորիթմ։\n\nՑուցադրված տվյալների ծառի ծածկի կտորի խտությունը տարբերվում է ըստ ընտրության - օգտագործեք քարտեզի լեգենդը, որպեսզի փոխեք ծառերի ծածկման նվազագույն խտության շեմքը:',
  },
  citation: {
    label: 'Մեջբերում',
    value:
      'Use the following credit when these data are displayed:\nSource: Hansen/UMD/Google/USGS/NASA, accessed through Global Forest Watch\n\nUse the following credit when these data are cited:\nHansen, M. C., P. V. Potapov, R. Moore, M. Hancher, S. A. Turubanova, A. Tyukavina, D. Thau, S. V. Stehman, S. J. Goetz, T. R. Loveland, A. Kommareddy, A. Egorov, L. Chini, C. O. Justice, and J. R. G. Townshend. 2013. “High-Resolution Global Maps of 21st-Century Forest Cover Change.” Science 342 (15 November): 850–53. Data available on-line from:https://glad.umd.edu/dataset/global-2010-tree-cover-30-m. Accessed through Global Forest Watch on 11/02/2025. www.globalforestwatch.org',
  },
};
